import * as React from 'react';
import { Title } from '../../../title';
import { I18n } from 'react-redux-i18n';
import { ConditionalField } from '../../../conditional-field';
import { FolderPicker } from '../../../folder-picker';
import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { QuestionnaireUpdateLocalDto } from '@modules/fhq-design-tool/dto/questionnaire-update-local-dto';
import { QuestionnaireManagementErrors } from '@modules/fhq-design-tool/controllers/questionnaire-validation';
import { QuestionnaireCreateLocalDto } from '@modules/fhq-design-tool/dto/questionnaire-create-local-dto';

import './invited.styles.scss';

export type InvitedProps = {
  errors?: QuestionnaireManagementErrors;
  folders: Array<FolderPrimaryListDto>;
  questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto;
  onChange: (questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto) => void;
};

export const Invited: React.FC<InvitedProps> = (props) => {
  const { onChange, questionnaire, folders, errors } = props;

  const handleMoveOnInvitationChange = React.useCallback((value: boolean) => {
    onChange({
      ...questionnaire,
      statusTab: {
        ...questionnaire.statusTab,
        moveOnInvite: value,
        inviteTargetFolderId: value ? questionnaire.statusTab.inviteTargetFolderId : null,
      },
    });
  }, [onChange, questionnaire]);

  const handleTargetFolderChange = React.useCallback((folderId: FolderPrimaryListDto['id']) => {
    onChange({
      ...questionnaire,
      statusTab: {
        ...questionnaire.statusTab,
        inviteTargetFolderId: folderId,
      },
    });
  }, [onChange, questionnaire]);

  return (
    <div className="FhqDesignToolStatusActionsInvited">
      <Title text={I18n.t('Invited')} margin="0 0 12px 0" />
      <ConditionalField 
        value={questionnaire.statusTab.moveOnInvite}
        metadata={{
          description: 'move-on-invitation-sent'
        }}
        onChange={handleMoveOnInvitationChange}
        label={I18n.t('Move on Invitation Sent')}
      >
        <FolderPicker 
          errors={errors?.properties?.inviteTargetFolder}
          required={questionnaire.statusTab.moveOnInvite}
          value={questionnaire.statusTab.inviteTargetFolderId ?? undefined}
          onChange={handleTargetFolderChange}
          metadata={{
            description: 'move-on-invitation-sent-folder',
          }}
          labelWidth={140}
          folders={folders}
          label={I18n.t('Choose Target Folder')}
        />
      </ConditionalField>
    </div>
  );
};